module.exports = __webpack_public_path__ + "static/img/06_1.d144283.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20250403/06_1.jpg
// module id = 4go9
// module chunks = 0